@if (lessonsRemaining !== 0) {
    <p class="freemium-reward-progress-bar__label"
         id="progress-bar-label">
        {{ 'freemiumreward.info_todo_part1' | translate }} {{ lessonsRemaining }}
        {{ 'freemiumreward.info_todo_part2' | translate }}{{ lessonsRemaining > 1 ? 's' : '' }} {{ 'freemiumreward.info_todo_part3' | translate }}
    </p>
}

<div class="freemium-reward-progress-bar__track"
     role="progressbar"
     aria-labelledby="progress-bar-label"
     aria-valuemax="3"
     [attr.aria-valuenow]="triggersCount">
    <div class="freemium-reward-progress-bar__inner-track"
         [style.width]="animatedPercent === 0 || animatedPercent === 100 ? animatedPercent + '%' : 'calc(' + animatedPercent + '% + 0.5rem)'"
         aria-hidden="true">
    </div>
    @for (position of dotPositions; track $index) {
        <div class="freemium-reward-progress-bar__marker"
             [class.freemium-reward-progress-bar__marker--filled]="animatedPercent >= position"
             [style.left.%]="position"
             aria-hidden="true">
        </div>
    }
    <div class="freemium-reward-progress-bar__gift-image"
         [class.freemium-reward-progress-bar__gift-image--is-shaking]="isShaking"
         aria-hidden="true">
    </div>
</div>

@if (isCompleted) {
    <button class="freemium-reward-progress-bar__button"
            data-e2e="freemium-reward-progress-bar-open-premium"
            (click)="onPremiumClick()">
        <span>{{ 'freemiumreward.get_reward' | translate }}</span>
    </button>
}
